import { Button, Grid, Typography } from '@mui/material';

/**
 * Content of one Care tile.
 * title       - tile heading
 * description - text under the heading
 * buttonLabel - action link text, shown in capitals
 * onClick     - action run when the link is clicked
 * disabled    - true to show the link greyed out (e.g. link not set yet)
 */
interface CareTileContentProps {
  title: string;
  description: string;
  buttonLabel: string;
  onClick: () => void;
  disabled?: boolean;
}

/**
 * MM-1132: heading, description and action link shared by all Care tiles.
 * Uses the same layout as the Billing "Request Your Balance" tile: description on the left and the
 * link on the right on larger screens. On phones the link goes under the description, right-aligned.
 * The link label is always in capitals and stays on one line.
 */
const CareTileContent = ({ title, description, buttonLabel, onClick, disabled }: CareTileContentProps) => (
  <Grid container spacing={2}>
    <Grid item xs={12} display={'flex'} flexDirection={'column'} justifyContent={'space-between'} gap={1.5}>
      <Typography variant='h2'>{title}</Typography>
      <Grid container>
        <Grid item xs={12} sm>
          <Typography variant='subtitle1'>{description}</Typography>
        </Grid>
        <Grid item xs={12} sm='auto' alignItems={'end'} textAlign={'end'} mt={{ xs: 1, sm: 0 }} pl={{ sm: 2 }}>
          <Button
            variant='text'
            size='small'
            sx={{ fontSize: '14px', padding: 0, whiteSpace: 'nowrap', textTransform: 'uppercase' }}
            onClick={onClick}
            disabled={disabled}
          >
            {buttonLabel}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);

export default CareTileContent;
